import { useAuth } from "@/lib/auth";
import { Navigate, useLocation } from "react-router-dom";

export default function Protected({ children, admin = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-fg/50">Chargement…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/espace" replace />;
  return children;
}
